import { render, staticRenderFns } from "./PagePurchaseGalleryProviders.vue?vue&type=template&id=1abb994a&"
import script from "./PagePurchaseGalleryProviders.vue?vue&type=script&lang=ts&"
export * from "./PagePurchaseGalleryProviders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports